import {
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Typography,
} from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { ColorsConstants } from "../../../cssUtils/constants";

const TIME_SLOTS = [
  { label: "24 Hours", value: 24 },
  { label: "36 Hours", value: 36 },
  { label: "48 Hours", value: 48 },
  { label: "72 Hours", value: 72 },
];

const TimeSlotDropdown = ({ value, onChange, error }) => {
  return (
    <FormControl fullWidth error={Boolean(error)}>
      <InputLabel shrink={Boolean(value)}>
        Scheduled Date *
      </InputLabel>

      <Select
        value={value}
        label="Scheduled Date *"
        onChange={(e) => onChange(e.target.value)}
        required
        IconComponent={ExpandMoreIcon}
        sx={{
          borderRadius: '8px',
          '& .MuiOutlinedInput-notchedOutline': {
            borderRadius: '8px',
            borderColor: '#DFE5EC',
          },
          '&:hover .MuiOutlinedInput-notchedOutline': {
            borderColor: '#DFE5EC',
          },
          '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
            borderColor: ColorsConstants.primaryBackgroundColor,
          },
        }}
        inputProps={{
          sx: {
            '& .MuiSelect-icon': {
              color: '#000000DE',
              fontSize: '1.2rem',
            },
          },
        }}
      >
        {TIME_SLOTS.map((slot) => (
          <MenuItem key={slot.value} value={slot.value}>
            {slot.label}
          </MenuItem>
        ))}
      </Select>

      {error && (
        <Typography variant="caption" color="error" sx={{ mt: 1 }}>
          {error}
        </Typography>
      )}
    </FormControl>
  );
};

export default TimeSlotDropdown;